import { Toast } from '@roo/roo';
import dayjs from 'dayjs';
/*
 * @Author: Enzo
 * @Date: 2021-06-08 15:27:01
 * @LastEditTime: 2021-07-21 09:59:01
 * @LastEditors: Enzo
 * @Description:
 * @FilePath: /waimai_cd_fe_greentech_c/src/utils/utils.js
 * God is watching you
 */
export const toastFail = function (msg, title = '提示') {
  Toast.open({
    title,
    children: msg,
    duration: 5000,
    theme: 'light',
    status: 'fail',
  });
};

export const toastSuccess = function (msg, title = '提示') {
  Toast.open({
    title,
    children: msg,
    duration: 5000,
    theme: 'light',
    status: 'success',
  });
};

export const getSafeDate = (value) => (dayjs(value).isValid() ? value : undefined);

export function getSizeString(size = 0) {
  const st = ['bit', 'KB', 'MB', 'GB', 'TB'];
  let unit = 0;
  while (size > 1024) {
    size /= 1024;
    unit++;
  }
  return `${Math.round(size * 100) / 100}${st[unit]}`;
}

export function genStr() {
  return `${Date.now().toString(36)}_${Math.random().toString(36).substring(2)}`;
}

// 解析章程文字
export function parseRuleText(str = '') {
  const lines = str
    .replace(/（/g, '(')
    .replace(/）/g, ')')
    .split(/[\n\r]/g)
    .filter(Boolean);
  const result = [];
  let title = '';
  let content = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const reg = /(第.*[章条]\s)(.*)/g;
    // console.log(line);
    const g = reg.exec(line);
    if (g) {
      if (title) {
        if (title.includes('章')) {
          title = `${title}  ${content.join('')}`;
          result.push({ title, content: [] });
        } else if ((title.includes('条') && !(/[；。]$/).test(content[0].trim())) && content[0].length < 8) {
          // console.log((/[;。]$/).test(content[0]), content);
          title = `${title}  ${content[0]}`;
          result.push({ title, content: content.slice(1) });
        } else {
          result.push({ title, content });
        }
      }
      title = g[1];
      content = g[2] ? [g[2]] : [];
    } else {
      content.push(line);
    }
  }
  result.push({ title, content });
  return result;
}
// 解析指南文字
export function parseHelpText(str = '') {
  const lines = str
    .replace(/\(/g, '（')
    .replace(/\)/g, '）')
    .split(/[\n\r]/g)
    .filter(Boolean);
  const result = [];
  let title = '';
  let content = [];
  for (let i = 0; i < lines.length; i++) {
    let line = lines[i];
    line = line.trim();
    const g = /^\D{1,2}、/g.exec(line);
    if (g) {
      if (title) {
        result.push({ title, content });
      }
      title = line;
      content = [];
    } else {
      content.push(line);
    }
  }
  result.push({ title, content });
  return result;
}

// 数字中文转换
export const numberMap = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];

const controller = new AbortController();
export const leaveTip = () => {
  window.addEventListener('beforeunload', (e) => {
    e.preventDefault();
    e.returnValue = '';
  }, { signal: controller.signal });
};
export const removeLeaveTip = () => {
  controller.abort();
};
// 各类基金类型
export const ProjectTypeEnums = {
  SciType: 1,
  InoType: 2,
};
export const TimeLine = (projectConfDto, timestamp = dayjs().unix()) => {
  const confSci = projectConfDto.find((t) => Number(t.type) === ProjectTypeEnums.SciType) || {};
  const confIno = projectConfDto.find((t) => Number(t.type) === ProjectTypeEnums.InoType) || {};
  const sciStartTime = confSci.startTime || timestamp + 1000;
  const sciEndTime = confSci.applyEndTime || timestamp - 1000;
  const inoStartTime = confIno.startTime || timestamp + 1000;
  const inoEndTime = confIno.applyEndTime || timestamp - 1000;
  const earlyTime = Math.min(sciStartTime, inoStartTime);
  const lastTime = Math.max(inoEndTime, sciEndTime);
  return {
    sciStartTime, sciEndTime, inoStartTime, inoEndTime, earlyTime, lastTime,
  };
};
